export const ProjectBackgroundTypes = {
  GRADIENT: 'gradient',
  IMAGE: 'image',
};

export const CardBackgroundStyleTypes = {
  FULL: 'full',
  HALF: 'half',
};

export const BoardTypes = {
  KANBAN: 'kanban',
  CALENDAR: 'calendar',
  GANTT: 'gantt',
};

export const BoardMembershipRoles = {
  EDITOR: 'editor',
  VIEWER: 'viewer',
};

export const ActivityTypes = {
  COPY_CARD: 'copyCard',
  CREATE_CARD: 'createCard',
  MOVE_CARD: 'moveCard',
  COMMENT_CARD: 'commentCard',
  JOIN_CARD: 'joinCard',
  LEFT_CARD: 'leftCard',
  ATTACHMENTS_ADD: 'attachmentsAdd',
  ATTACHMENTS_REMOVE: 'attachmentsRemove',
  ACTION_ADD: 'actionAdd',
  ACTION_REMOVE: 'actionRemove',
  ACTION_DONE: 'actionDone',
  ACTION_UNDONE: 'actionUndone',
  ACTION_TO_CARD: 'actionToCard',
  ACTION_MEMBER_ADD: 'actionMemberAdd',
  ACTION_MEMBER_REMOVE: 'actionMemberRemove',
  ACTION_DUE_DATE: 'actionDueDate',
  UPDATE_DATE_CARD: 'updateDateCard',
  DESCRIPTION_UPDATE_CARD: 'descriptionUpdateCard',
  NAME_UPDATE_CARD: 'nameUpdateCard',
  UPDATE_COMPLETE_CARD: 'updateCompleteCard',
  CARD_DUE_REMINDER: 'cardDueReminder',
};

export const AdminActionTypes = {
  UPDATE_NUMBER: 'updateNumber',
  UPDATE_EXPIRED: 'updateExpired',
};

export const BoardCustomFieldsTypes = {
  CHECK: 'check',
  OPTIONS: 'options',
  TIME: 'time',
  TEXT: 'text',
  NUMBER: 'number',
};

export const AutomationTypes = {
  MOVE_CARD: 'moveCard',
  ADD_LABEL: 'addLabel',
  EXPIRATION_DATE: 'expirationDate',
  ADD_ME: 'addMe',
  MARK_CARD: 'markCard',
};

export const PayTypes = {
  // 支付成功
  SUCCESS: 'success',
  // 未支付
  UNPAID: 'unpaid',
  // 订单失效
  EXPIRED: 'expired',
};

export const PayTypesMap = new Map([
  [PayTypes.SUCCESS, '支付成功'],
  [PayTypes.UNPAID, '未支付'],
  [PayTypes.EXPIRED, '订单失效'],
]);

export const AutomationRuleTriggerTypes = {
  createCard: '新建卡片',
  // markAsCompleted: '标记卡片完成',
  // moveCardToList: '移动卡片到列表',
  addMember: '添加卡片成员',
  // addAttachment: '添加附件',
  // changeDueDate: '变更卡片截止日期',
  // addLabel: '添加标签到卡片',
  // addComment: '添加评论',
  // dueDateOverdue: '卡片截止日期过期',
};

// export const AutomationRuleConditionTypes = {
//   and: '且',
//   or: '或',
// };

export const AutomationRuleConditions = {
  list: '卡片所在列',
  // status: '卡片状态',
  // dueDate: '卡片截止日期',
  // startDate: '卡片开始日期',
  // label: '卡片标签',
  // attachment: '卡片有附件',
  // comment: '卡片有评论',
  member: '卡片成员',
};

export const AutomationRuleActions = {
  // moveToListBottom: '移动到列表底部',
  moveToList: '移动到列表',
  // moveToBoard: '移动到看板',
  // createCard: '新建卡片',
  // changeCardStatus: '变更卡片状态',
  // changeCardTitle: '变更卡片标题',
  // addCardMember: '添加卡片成员',
  // removeCardMember: '移除卡片成员',
  // clearCardMembers: '清空卡片成员',
  // changeDueDate: '变更卡片截止日期',
  // addCardLabel: '添加卡片标签',
  // removeCardLabel: '移除卡片标签',
  // clearCardLabels: '清空卡片标签',
  // changeCardDescription: '变更卡片描述',
  // addComment: '添加评论',
};

export const BoardCardFieldsTypes = {
  NUMBER: 'number',
  MEMBER: 'member',
  LABEL: 'label',
  DATE: 'date',
  TIMER: 'timer',
  STORYPOINTS: 'storypoints',
  ATTACHMENT: 'attachment',
  BACKGROUND: 'background',
  CUSTOM_FIELD: 'customField',
  TASK: 'task',
};

export const BoardCardFieldsTypesMap = {
  [BoardCardFieldsTypes.NUMBER]: '编号',
  [BoardCardFieldsTypes.MEMBER]: '成员',
  [BoardCardFieldsTypes.LABEL]: '标签',
  [BoardCardFieldsTypes.DATE]: '日期',
  [BoardCardFieldsTypes.TIMER]: '计时器',
  [BoardCardFieldsTypes.STORYPOINTS]: '复杂度',
  [BoardCardFieldsTypes.ATTACHMENT]: '附件',
  [BoardCardFieldsTypes.BACKGROUND]: '封面',
  [BoardCardFieldsTypes.CUSTOM_FIELD]: '自定义字段',
  [BoardCardFieldsTypes.TASK]: '子任务',
};

export const FunctionTypes = {
  BOARD_EXPORT: 'boardExport',
  BOARD_IMPORT: 'boardImport',
  BOARD_COPY: 'boardCopy',
};

export const FunctionTypesMap = new Map([
  [FunctionTypes.BOARD_EXPORT, '导出看板'],
  [FunctionTypes.BOARD_IMPORT, '导入看板'],
  [FunctionTypes.BOARD_COPY, '复制看板'],
]);
